export default __webpack_public_path__ + "static/media/acknowledgements_img1.6180e6c5.png";